import { createTRPCReact, type CreateTRPCReact } from '@trpc/react-query';
import {
  ProviderTrpcRouter,
  type ReactQueryOptions,
  type RouterInputs,
  type RouterOutputs,
} from '@duke-hq/svc-api/provider/web-api';

export const trpcTenant: CreateTRPCReact<ProviderTrpcRouter, unknown> =
  createTRPCReact<ProviderTrpcRouter>();

export type ProviderTrpcClient = typeof trpcTenant;

export type { ReactQueryOptions, RouterInputs, RouterOutputs };
